import React, { useEffect, useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.role === "admin") {
      navigate("/admin", { replace: true });
    }
  }, [user, navigate]);

  if (user === null) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <span className="overline">Authenticating…</span>
      </div>
    );
  }
  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin", { replace: true });
    else setError(res.error || "Login failed");
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen bg-[#050505] text-[#f5f5f5] flex items-center justify-center px-6"
    >
      <div className="w-full max-w-md">
        <div className="overline mb-8">
          <span className="accent-bar" />
          Restricted · Admin
        </div>
        <h1
          className="font-display font-light leading-[0.9] tracking-[-0.03em] mb-12"
          style={{ fontSize: "clamp(2.4rem, 6vw, 4.5rem)" }}
        >
          The <span className="italic text-[#c01515]">vault</span>.
        </h1>

        <form onSubmit={onSubmit} className="space-y-2" data-testid="admin-login-form">
          <label className="block">
            <span className="overline block mb-1">Email</span>
            <input
              data-testid="admin-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="admin email"
              className="input-line"
            />
          </label>
          <label className="block pt-6">
            <span className="overline block mb-1">Passphrase</span>
            <input
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
              className="input-line"
            />
          </label>

          {error && (
            <p
              data-testid="admin-login-error"
              className="overline text-[#c01515] pt-4"
            >
              ✗ {error}
            </p>
          )}

          <div className="pt-10 flex items-center justify-between gap-4 flex-wrap">
            <button
              data-testid="admin-login-submit"
              type="submit"
              disabled={loading}
              className="btn-sharp btn-accent"
            >
              <span>{loading ? "Verifying…" : "Enter"}</span>
              <span>→</span>
            </button>
            <a
              data-testid="admin-login-back"
              href="/"
              className="nav-link"
            >
              ← Back to portfolio
            </a>
          </div>
        </form>
      </div>
    </div>
  );
}
